<template>
    <application-modal v-model="moveOutModal" @collapse="clearDate">
        <v-btn
            data-testid="open-move-out-btn"
            class="open-move-out-btn error large white--text px-3"
            block
            slot="modal-trigger"
            @click.stop="moveOutModal = true"
        >
            <v-icon class="mr-2">exit_to_app</v-icon>
            Intent to Vacate
        </v-btn>
        <div slot="modal-title">Intent to Vacate</div>
        <div slot="modal-body">
            <div class="mt-3 ml-1 text-h6 pb-3" data-testid="advisory-message">
                  <span v-if="moveOutDate">
                      Click "Intent to Vacate" to schedule move out date for {{ formatDate(moveOutDate) }}.
                  </span>
              <span v-else>Select a valid move out date.</span>
            </div>
            <v-date-picker
                data-testid="vacate-move-out-datepicker"
                class="vacate-move-out-datepicker"
                style="border: 1px #2278CF solid"
                color="primary"
                landscape
                full-width
                :min="today"
                v-model="moveOutDate"
            />
            <div class="mt-3 ml-1 text-h6 pb-3" data-testid="advisory-message">
                <span>Please add a note for the manager.</span>
            </div>
            <v-textarea
                data-testid="intent-vacate-note-textarea"
                class="intent-vacate-note-textarea"
                filled
                name="moveout-note"
                label="Note"
                auto-grow
                v-model="moveOutNote"
                hint="A copy of the above note will be emailed to the store manager"
            />
        </div>
        <v-btn
            data-testid="move-out-btn"
            class="move-out-btn primary"
            slot="create-button"
            :loading="loading"
            :disabled="!moveOutDate"
            @click="moveOut"
        >
          Intent to Vacate
        </v-btn>
    </application-modal>
</template>

<script>
/* eslint-disable eqeqeq */
import ApplicationModal from "@/components/ApplicationModal";
import { mapState } from "vuex";
import moment from "moment-timezone";

export default {
  name: "MoveOut",
  props: ["ledgerId", "ledgers"],
  data() {
    return {
      moveOutModal: false,
      loading: false,
      moveOutDate: "",
      moveOutNote: ""
    };
  },
  methods: {
    clearDate() {
      this.moveOutDate = "";
    },

    formatDate(date) {
      return moment.utc(date).format("MM/DD/YYYY");
    },

    moveOut() {
      this.loading = true;

      let payload = {
        facilityId: this.$route.params.facilityId,
        tenantId: this.$route.params.tenantId,
        ledgerId: this.ledgerId,
        move_out_date: this.moveOutDate,
        move_out_note: this.moveOutNote
      };

      this.$store.dispatch("scheduleMoveOut", payload)
        .then(() => {
          this.$store.dispatch("handleSuccess", "Intent to Vacate scheduled!");
          this.moveOutModal = false;
          this.moveOutNote = "";
          this.loading = false;
          this.clearDate();
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.loading = false;
        });
    }
  },
  computed: {
    ...mapState({
      facility: state => state.facilities.facility
    }),
    today() {
      return new moment.tz(this.timeZone).format("YYYY-MM-DD");
    },

    unitId() {
      return this.ledgers.filter(ledger => ledger.pms_ledger_id == this.ledgerId)[0].facility_unit.name;
    },

    timeZone() {
      if (!this.facility || !this.facility.time_zone) {
        return "America/New_York";
      }
      return this.facility.time_zone;
    }
  },
  components: {
    ApplicationModal
  }
};
</script>
<style>
  .v-text-field__details{
    margin-left: -12px;
  }
</style>
